export function videoBg() {
    if (window.innerWidth < 1280) return;
    document.querySelectorAll(".section-poster").forEach((container) => {
        const src = container.dataset.src;

        if (!src) return;

        let element;

        if (isYouTubeUrl(src)) {
            const videoId = extractYouTubeId(src);
            if (!videoId) return;

            element = document.createElement("iframe");
            element.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&loop=1&playlist=${videoId}`;
            element.setAttribute("frameborder", "0");
            element.setAttribute("allow", "autoplay; fullscreen");
            element.setAttribute("allowfullscreen", "");
        } else if (isVimeoUrl(src)) {
            const videoId = extractVimeoId(src);
            if (!videoId) return;

            element = document.createElement("iframe");
            element.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&loop=1&background=1`;
            element.setAttribute("frameborder", "0");
            element.setAttribute("allow", "autoplay; fullscreen");
            element.setAttribute("allowfullscreen", "");
        } else {
            element = document.createElement("video");
            element.src = src;
            element.autoplay = true;
            element.muted = true;
            element.loop = true;
            element.playsInline = true;
            element.setAttribute("preload", "auto");
            element.setAttribute("muted", "");
        }

        container.appendChild(element);
    });

    function isYouTubeUrl(url) {
        return /youtube\.com|youtu\.be/.test(url);
    }

    function isVimeoUrl(url) {
        return /vimeo\.com/.test(url);
    }

    function extractYouTubeId(url) {
        const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/);
        return match ? match[1] : "";
    }

    function extractVimeoId(url) {
        const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        return match ? match[1] : "";
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/videoBg.js